import { type TypographyProps } from '../Typography';

export const selectionControlTypographyProps: TypographyProps = {
  color: 'inherit',
  typographyType: 'bodyShortMedium',
  as: 'span',
};
